import { ThreepidSource } from "@dewo/app/graphql/types";
import { Button, Space, Typography, Image } from "antd";
import React, { FC, useCallback } from "react";
import ConnectToDiscordGraphic from "@dewo/app/assets/connect-to-discord.svg";
import { ThreepidAuthButton } from "../../../auth/buttons/ThreepidAuthButton";
import { OnboardingUSPs } from "./OnboardingUSPs";
import { UserPromptStepComponentProps } from "../../types";

const usps = [
  "🏰   Get special access with your Discord roles",
  "💬   Receive task updates directly in Discord",
  // "🌎   Discover DAOs based on the servers you're in",
];

export const OnboardingConnectDiscord: FC<UserPromptStepComponentProps> = ({
  onNext,
}) => {
  const handleNext = useCallback(() => onNext(), [onNext]);
  return (
    <>
      <Typography.Title level={2} style={{ textAlign: "center" }}>
        Link your Discord account
      </Typography.Title>
      <Typography.Paragraph
        type="secondary"
        style={{ textAlign: "center", fontSize: "130%" }}
      >
        Dework works better with Discord connected
      </Typography.Paragraph>
      <Image
        src={ConnectToDiscordGraphic.src}
        preview={false}
        style={{ width: "40%" }}
        className="mx-auto"
      />
      <OnboardingUSPs usps={usps} />
      <Space direction="vertical" size="small" align="center">
        <ThreepidAuthButton
          source={ThreepidSource.discord}
          children="Connect Discord"
          type="primary"
          size="large"
          style={{ alignSelf: "center" }}
          name="Onboarding Discord: connect"
        />
        <Button
          type="text"
          style={{ alignSelf: "center" }}
          className="text-secondary"
          name="Onboarding Discord: skip"
          onClick={handleNext}
        >
          Skip
        </Button>
      </Space>
    </>
  );
};
